import { Stack } from "@mui/material";
import {
  DatagridConfigurable,
  DateField,
  DateInput,
  FilterForm,
  List,
  TextField,
  TextInput,
} from "react-admin";

const postFilters = [
  <TextInput source="q" label="Search" alwaysOn />,
  <DateInput source="created_from_at" label="From" alwaysOn />,
  <DateInput source="created_to_at" label="To" alwaysOn />,
];
const ListToolbar = () => (
  <Stack direction="row" justifyContent="space-between">
    <FilterForm disableSaveQuery filters={postFilters} />
  </Stack>
);

const BankOneSpanAccountList = () => (
  <List sort={{ field: "created_at", order: "DESC" }}>
    <ListToolbar />
    <DatagridConfigurable rowClick="show">
      <TextField source="sBank" label="Bank Name" />
      <TextField source="sEmail" label="Email" />
      <TextField source="sFirstName" label="First Name" />
      <TextField source="sLastName" label="Last Name" />
      <DateField source="created_at" label="Created Time" />
    </DatagridConfigurable>
  </List>
);

export default BankOneSpanAccountList;
